<template>
  <div class="row">
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5>Asset List</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <div class="form-inline ml-auto">
              <div class="button-group ">
                <button type="button" class="btn btn-sm btn-soft-primary dropdown-toggle" data-toggle="dropdown" id="dropDownFilter">Action<span class="caret"></span></button>
                <ul class="dropdown-menu p-2" aria-labelledby="dropDownFilter">
                  <li><a href="javascript:void(0)" class="small" tabIndex="-1" data-toggle="modal" data-target="#modalProcessAsset" data-backdrop="static" data-keyboard="false">Process Akumulasi</a></li>
                </ul>
                <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" v-show="authUser.permissions.vehicle_outlet_select">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu p-2" >
                  <span>Outlet:</span>
                  <div class="dropdown-divider"></div>
                  <li v-for="ct in branchList" :key="ct.id">
                    <a href="#" class="small" tabIndex="-1">
                      <input type="checkbox" :value="ct.branch_no" v-model="filterOutlet"/>&nbsp; {{ ct.name }}
                    </a>
                  </li>
                </ul>
                <button type="button" class="btn btn-sm btn-soft-primary" @click="addAsset">
                  <i class="fa fa-plus" aria-hidden="true"></i> New
                </button>
                <button type="button" class="btn btn-sm btn-hard-primary" data-toggle="modal" data-target="#modalProcessAsset" data-backdrop="static" data-keyboard="false">Process</button>
                <button type="button" class="btn btn-sm btn-soft-outline-primary" @click="refreshAsset">
                  <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                </button>
                <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshAsset"></date-picker>
                rows:
                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                  <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                </select>
                <span class="mr-1">
                  Total rows: <b>{{ rowsTotal }}</b>
                </span>
              </div>
              <div class="form-group mx-sm-3 mb-2">
                  <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
              </div>
              <span class="mr-1">
                page:
                <select v-model="currentPage">
                  <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                </select>
                / {{ pageLength }}
              </span>
              <nav aria-label="Page navigation example" class="pull-right">
                  <ul class="pagination">
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                              <i class="fa fa-angle-left" aria-hidden="true"></i>
                          </a>
                      </li>
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                              <i class="fa fa-angle-right" aria-hidden="true"></i>
                          </a>
                      </li>
                  </ul>
              </nav>
            </div>

            <table class="table table-item mb-0 table-sm table-hover">
                <thead>
                    <tr>
                        <th>
                          <label class="form-checkbox">
                            <input type="checkbox" v-model="selectAll" @click="select">
                            <i class="form-icon"></i>
                          </label>
                        </th>
                        <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                          {{ t.name }}
                          <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-if="filterData.length < 1">
                    <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                  </tr>
                  <tr v-for="d in filterData" :key="d.id">
                    <td>
                      <label class="form-checkbox">
                          <input type="checkbox" :value="d.id" v-model="selected">
                          <i class="form-icon"></i>
                        </label>
                    </td>
                    <td>
                      <span class="badge badge-success" v-if="d.condition === 'ready'">{{ d.condition }}</span>
                      <span class="badge badge-danger" v-else>{{ d.condition }}</span>
                    </td>
                    <td @click="editData(d.id)" class="text-ref-sales"><b>{{ d.asset_no }}</b></td>
                    <td class="text-center">{{ d.internal_number }}</td>
                    <td>{{ d.serial_number }}</td>
                    <td>{{ d.type_id }}</td>
                    <td>{{ d.asset_name }}</td>
                    <td class="text-center">{{ d.date_buy | dateFormat('DD/MM/YYYY') }}</td>
                    <td class="text-center">{{ d.date_reduce | dateFormat('DD/MM/YYYY') }}</td>
                    <td class="text-center">{{ d.asset_age }}</td>
                    <td class="text-center">{{ d.asset_age_remaining }}</td>
                    <td class="text-right">{{ d.asset_amount | currency }}</td>
                    <td class="text-right">{{ d.asset_amount_reduce | currency }}</td>
                    <td class="text-right">{{ d.asset_fix_amount | currency }}</td>
                    <td>{{ d.date_process | dateFormat('DD/MM/YYYY') }}</td>
                    <td class="text-center">
                      <span v-if="d.journal_beli_count > 0 && d.journal_beli_count <= 1"><i class="fa fa-check" style="color: green;"></i></span>
                    </td>
                    <td class="text-center"><b>{{ d.journal_akumulasi_count }}</b></td>
                  </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <AssetModal @processDate="processDate"/>
  </div>
</template>

<script>
import axios from 'axios'
import { assetUrl, getHeader } from '@/config'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import AssetModal from '@/components/finance/AssetModal.vue'

export default {
  name: 'AssetList',
  components: { DatePicker, Loading, AssetModal },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      filterOutlet: [],
      startDate: [date1, date2],
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'Condition',
        prop: 'condition',
        align: 'text-left'
      }, {
        name: 'Asset No.',
        prop: 'asset_no',
        align: 'text-left'
      }, {
        name: 'Internal No.',
        prop: 'internal_number',
        align: 'text-center'
      }, {
        name: 'Serial Number',
        prop: 'serial_number',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type_id',
        align: 'text-left'
      }, {
        name: 'Name',
        prop: 'asset_name',
        align: 'text-left'
      }, {
        name: 'Tgl. Transaksi',
        prop: 'date_buy',
        align: 'text-center'
      }, {
        name: 'Tgl. Mulai Akumulasi',
        prop: 'date_reduce',
        align: 'text-center'
      }, {
        name: 'Umur Ekonomis',
        prop: 'asset_age',
        align: 'text-center'
      }, {
        name: 'Sisa Umur',
        prop: 'asset_age_remaining',
        align: 'text-center'
      }, {
        name: 'Harga Asset',
        prop: 'asset_amount',
        align: 'text-right'
      }, {
        name: 'Harga Penyusutan',
        prop: 'asset_amount_reduce',
        align: 'text-right'
      }, {
        name: 'Sisa',
        prop: 'asset_fix_amount',
        align: 'text-right'
      }, {
        name: 'Process',
        prop: 'date_process',
        align: 'text-left'
      }, {
        name: 'Journal Beli Count',
        prop: 'journal_beli_count',
        align: 'text-center'
      }, {
        name: 'Journal Akumulasi Count',
        prop: 'journal_akumulasi_count',
        align: 'text-center'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshAsset()
    this.$store.dispatch('getRowTable')
  },
  methods: {
    async processDate (value) {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i],
          date_process: value === null ? new Date().toISOString() : value
        }
        console.log(obj)
        await axios.post(assetUrl + '/process', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$Progress.finish()
            this.loader.isLoading = false
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.refreshAsset()
      await this.$swal('Success', 'Success Process date', 'success')
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    editData: function (id) {
      var value = this.dataRaw.find(d => d.id === id)
      this.$emit('editAsset', value.id)
    },
    addAsset: function () {
      this.$emit('newAsset')
    },
    refreshAsset () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      axios.get(assetUrl + '?begin=' + begin + '&end=' + end, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
        })
        .catch(error => {
          this.loader.isLoading = false
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      branchList: state => state.branches.branchList,
      rowsTable: state => state.data.rowsTable
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterOutlet.length > 0) {
          for (let i = 0; i < this.filterOutlet.length; i++) {
            if (d.outlet_code.toString().toLowerCase().indexOf(this.filterOutlet[i].toString().toLowerCase()) > -1) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  }
}
</script>
